import { render, staticRenderFns } from "./switchAudio.vue?vue&type=template&id=76784ac1&scoped=true"
import script from "./switchAudio.vue?vue&type=script&lang=js"
export * from "./switchAudio.vue?vue&type=script&lang=js"
import style0 from "./switchAudio.vue?vue&type=style&index=0&id=76784ac1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76784ac1",
  null
  
)

export default component.exports